export const getContactEmail = (locale: string) => {
  const defaultMail = 'redakcja@trans.info';

  if (locale === 'de') {
    return 'redaktion@trans.info';
  }

  return defaultMail;
};
